import { render, staticRenderFns } from "./ItemDepartmentB.vue?vue&type=template&id=68fe6291&scoped=true&"
import script from "./ItemDepartmentB.vue?vue&type=script&lang=js&"
export * from "./ItemDepartmentB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fe6291",
  null
  
)

export default component.exports